import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Sparkles, Rocket, Workflow, Link2, Bot } from 'lucide-react';

const SplashNav: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  const tabs = [
    { to: '/', label: 'Overview', icon: Sparkles, activeColor: 'bg-violet-100 text-violet-700 border-violet-200', hoverColor: 'hover:bg-violet-50 hover:text-violet-600 hover:border-violet-200' },
    { to: '/splash/engine', label: 'Engine', icon: Rocket, activeColor: 'bg-violet-100 text-violet-700 border-violet-200', hoverColor: 'hover:bg-violet-50 hover:text-violet-600 hover:border-violet-200' },
    { to: '/splash/automation', label: 'Automation', icon: Workflow, activeColor: 'bg-cyan-100 text-cyan-700 border-cyan-200', hoverColor: 'hover:bg-cyan-50 hover:text-cyan-600 hover:border-cyan-200' },
    { to: '/splash/affiliate', label: 'Affiliate', icon: Link2, activeColor: 'bg-emerald-100 text-emerald-700 border-emerald-200', hoverColor: 'hover:bg-emerald-50 hover:text-emerald-600 hover:border-emerald-200' },
    { to: '/splash/ai-marketing', label: 'AI Growth', icon: Bot, activeColor: 'bg-cyan-100 text-cyan-700 border-cyan-200', hoverColor: 'hover:bg-cyan-50 hover:text-cyan-600 hover:border-cyan-200' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-600 to-blue-600 flex items-center justify-center">
            <Sparkles className="h-4 w-4 text-white" />
          </div>
          <span className="text-sm font-bold text-slate-800 hidden sm:inline">Aurelian Marketing Engine (AME)</span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.to;
            return (
              <Link
                key={tab.to}
                to={tab.to}
                className={`px-3 sm:px-4 py-2 rounded-lg text-xs font-medium border whitespace-nowrap flex items-center gap-1.5 transition-all ${
                  isActive ? tab.activeColor : `text-slate-500 border-transparent ${tab.hoverColor}`
                }`}
              >
                <tab.icon className="h-3.5 w-3.5" />
                {tab.label}
              </Link>
            );
          })}
        </div>
        <div className="hidden md:flex items-center gap-3 flex-shrink-0">
          <Link to="/pricing" className="text-xs text-slate-500 hover:text-slate-700 transition-colors">Pricing</Link>
          <Link
            to={user ? '/dashboard' : '/login'}
            className="px-4 py-2 bg-gradient-to-r from-violet-600 to-blue-600 text-white rounded-lg text-xs font-semibold hover:shadow-md transition-all"
          >
            {user ? 'Dashboard' : 'Sign In'}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default SplashNav;
